import React from "react";
import { Instagram, Music2, Star, Facebook } from "lucide-react";

const SOCIALS = [
  {
    id: "instagram",
    label: "Instagram",
    handle: "@chelsearaywrites",
    aria: "Follow Chelsea Ray on Instagram",
    href: "https://www.instagram.com/chelsearaywrites",
    icon: Instagram,
    testId: "social-instagram",
  },
  {
    id: "tiktok",
    label: "TikTok",
    handle: "@chelsearaywrites",
    aria: "Follow Chelsea Ray on TikTok",
    href: "https://www.tiktok.com/@chelsearaywrites",
    icon: Music2,
    testId: "social-tiktok",
  },
  {
    id: "facebook",
    label: "Facebook",
    handle: "Chelsea Ray",
    aria: "Follow Chelsea Ray on Facebook",
    href: "https://www.facebook.com/profile.php?id=61578028846197",
    icon: Facebook,
    testId: "social-facebook",
  },
  {
    id: "goodreads",
    label: "Goodreads",
    handle: "Chelsea Ray",
    aria: "Follow Chelsea Ray on Goodreads",
    href: "https://www.goodreads.com/author/show/57797883.Chelsea_Ray",
    icon: Star,
    testId: "social-goodreads",
  },
];

export default function Socials() {
  return (
    <section
      id="socials"
      data-testid="socials-section"
      className="relative py-24 md:py-32 bg-ocean-base reveal"
      aria-label="Find the author online"
    >
      <div className="parchment-overlay absolute inset-0" aria-hidden="true" />

      <div className="relative max-w-5xl mx-auto px-6 md:px-10 text-center">
        <p className="font-accent text-[10px] text-[#c9a25a] reveal-up">Connect</p>
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#f2e8d5] mt-4 reveal-blur">
          Find Me Online
        </h2>
        <p className="mt-6 text-[#a8b4c0] max-w-xl mx-auto reveal-up">
          Sail beside Chelsea Ray as she shares character art, snippets, sea
          shanties, and the world of <em>Against All Waves</em>.
        </p>

        {/* Goodreads dedicated section so #goodreads anchor scrolls here too */}
        <div id="goodreads" className="absolute -top-24" aria-hidden="true" />

        <ul className="mt-14 grid grid-cols-1 sm:grid-cols-2 gap-5 reveal-up" data-stagger="140">
          {SOCIALS.map(({ id, label, handle, aria, href, icon: Icon, testId }) => (
            <li key={id} data-reveal-child="">
              <a
                data-testid={testId}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={aria}
                className="social-card group relative flex items-center gap-5 border border-[#c9a25a]/25 bg-[#0a1118]/50 backdrop-blur-sm p-5 md:p-6 text-left transition-all duration-500 hover:border-[#e8c888]/80 hover:bg-[#c9a25a]/8 hover:-translate-y-1"
              >
                {/* Icon badge */}
                <span className="relative shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-full border border-[#c9a25a]/40 bg-[#050a0f]/60 flex items-center justify-center transition-all duration-500 group-hover:border-[#e8c888]">
                  <span className="absolute inset-0 rounded-full bg-[#c9a25a]/0 group-hover:bg-[#c9a25a]/20 blur-lg transition-all duration-500" />
                  <Icon
                    size={22}
                    className="relative text-[#c9a25a] group-hover:text-[#f3dca0] transition-colors duration-500"
                    aria-hidden="true"
                  />
                </span>

                {/* Label + URL */}
                <span className="flex-1 min-w-0">
                  <span className="block font-accent text-[10px] text-[#c9a25a]">
                    {label}
                  </span>
                  <span
                    data-testid={`${testId}-handle`}
                    className="block font-display italic text-lg md:text-xl text-[#f2e8d5] mt-1 group-hover:text-[#f8efd9] transition-colors duration-500"
                  >
                    {handle}
                  </span>
                </span>

                {/* Arrow */}
                <span
                  aria-hidden="true"
                  className="shrink-0 text-[#c9a25a]/70 group-hover:text-[#f3dca0] group-hover:translate-x-1 transition-all duration-500 text-lg"
                >
                  →
                </span>

                {/* Bottom gold hairline animation */}
                <span
                  aria-hidden="true"
                  className="absolute bottom-0 left-0 h-px w-0 bg-gradient-to-r from-transparent via-[#c9a25a] to-transparent group-hover:w-full transition-all duration-700"
                />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
